import { Module } from 'vuex';
import { state } from './state';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { AppStore } from './types';
import { RootState } from '@/shared/config/store/types';

const namespaced = true;

export const appStore: Module<AppStore, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
